customElements.define(
  'steps-with-media',
  class StepsWithMedia extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        this.steps = this.querySelectorAll('.steps-with-media__step');
        this.panels = this.querySelectorAll('.steps-with-media__media-panel');
        this.autoplay = this.hasAttribute('data-video-autoplay');

        this.steps.forEach((step) => {
          step.addEventListener('click', () => this.activateStep(step));
        });

        // Theme editor integration
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const index = event.target.dataset.stepIndex;
          const step = this.querySelector(`.steps-with-media__step[data-step-index="${index}"]`);
          if (step) this.activateStep(step);
        });
      });
    }

    activateStep(step) {
      const index = step.dataset.stepIndex;

      // Pause videos in currently active panels
      this.panels.forEach((p) => {
        if (p.classList.contains('active')) {
          var v = p.querySelector('video');
          if (v) v.pause();
        }
        p.classList.remove('active');
      });

      this.steps.forEach((s) => s.classList.remove('active'));
      step.classList.add('active');

      const panel = this.querySelector(`.steps-with-media__media-panel[data-step-index="${index}"]`);
      if (panel) {
        panel.classList.add('active');
        var v = panel.querySelector('video');
        if (v) {
          v.currentTime = 0;
          if (this.autoplay) v.play().catch(function() {});
        }
      }
    }
  }
);
